export const reportSelector = (state) => state.report;
export const reportRiskTravelSelector = (state) => reportSelector(state).reportRiskTravel;
export const reportLastReportDataSelector = (state) => reportSelector(state).lastReportData;
export const reportTravelingScoring = (state) => reportSelector(state).travelingScoring;
